module.exports = __webpack_public_path__ + "img/mercedes-logo.b6669867.webp";